<template>
  <div>
    <vx-card class="h-full min-height">
      <div>
        <h4 class="">{{ $t("profile.MyDeviceRentals") }}</h4>
        <vs-divider class="customer-divider my-4" />
      </div>
      <div class="height-300 mt-8">
        <div class="vx-row flex justify-center items-center mb-base">
          <div class="vx-col w-full sm:w-full md:w-full lg:w-1/3 xl:w-1/3 mb-4">
            <vs-button
              type="filled"
              color="warning"
              class="w-full h6 tab-button"
              :class="
                $route.meta.rent_tab == 1
                  ? 'text-white'
                  : 'vs-button-border text-warning'
              "
              @click="moveTo('', 1)"
              >{{ $t("myDeviceRentals.tabs.tab1") }}</vs-button
            >
          </div>
          <div class="vx-col w-full sm:w-full md:w-full lg:w-1/3 xl:w-1/3 mb-4">
            <vs-button
              type="filled"
              color="warning"
              class="w-full h6 tab-button"
              :class="
                $route.meta.rent_tab == 2
                  ? 'text-white'
                  : 'vs-button-border text-warning'
              "
              @click="moveTo('/expiring-leases', 2)"
              >{{ $t("myDeviceRentals.tabs.tab3") }}</vs-button
            >
          </div>
          <div class="vx-col w-full sm:w-full md:w-full lg:w-1/3 xl:w-1/3 mb-4">
            <vs-button
              type="filled"
              color="warning"
              class="w-full h6 tab-button"
              :class="
                $route.meta.rent_tab == 3
                  ? 'text-white'
                  : 'vs-button-border text-warning'
              "
              @click="moveTo('/expired-leases', 3)"
              >{{ $t("myDeviceRentals.tabs.tab2") }}</vs-button
            >
          </div>
        </div>
        <div>
          <div id="data-rental-device-view" class="data-list-container">
            <vs-table
              ref="table"
              :max-items="itemsPerPage"
              :data="rentalList"
              :noDataText="noDataText"
              :sst="true"
            >
              <template slot="thead">
                <vs-th class="text-left">{{
                  $t("myDeviceRentals.table.deviceSerial")
                }}</vs-th>
                <vs-th class="text-left" v-if="$route.meta.rent_tab != 3">{{
                  $t("myDeviceRentals.table.startDate")
                }}</vs-th>
                <vs-th class="text-left" v-if="$route.meta.rent_tab != 3">{{
                  $t("myDeviceRentals.table.endDate")
                }}</vs-th>
                <vs-th class="text-center d-none" v-if="$route.meta.rent_tab != 3">{{
                  $t("myDeviceRentals.table.actions")
                }}</vs-th>
                <vs-th class="text-left" v-if="$route.meta.rent_tab == 3">{{
                  $t("myDeviceRentals.table.leasedBy")
                }}</vs-th>
              </template>

              <template slot-scope="{ data }">
                <tbody>
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].device_serial">
                      <p class="font-medium truncate mr-0">
                        {{
                          data[indextr].device_serial
                            ? data[indextr].device_serial
                            : "-"
                        }}
                      </p>
                    </vs-td>
                    <vs-td
                      :data="data[indextr].rent_start_date"
                      v-if="$route.meta.rent_tab != 3"
                    >
                      <p class="font-medium truncate mr-0">
                        {{
                          data[indextr].rent_start_date
                            ? getDateFormat(data[indextr].rent_start_date)
                            : "-"
                        }}
                      </p>
                    </vs-td>
                    <vs-td
                      :data="data[indextr].end_date"
                      v-if="$route.meta.rent_tab != 3"
                    >
                      <p class="font-medium truncate mr-0">
                        {{
                          data[indextr].rent_end_date
                            ? getDateFormat(data[indextr].rent_end_date)
                            : "-"
                        }}
                      </p>
                    </vs-td>
                    <vs-td class="d-none" v-if="$route.meta.rent_tab != 3">
                      <p class="font-medium truncate mr-0 text-center">
                        <vs-button
                          type="filled"
                          color="#a6a6a6"
                          class="px-2 py-2"
                          :disabled="
                            data[indextr].is_renewable == true ? false : true
                          "
                          target
                          :href="{
                            url: `${data[indextr].tenant.renew_link}?device=${data[indextr].device_serial}`,
                          }"
                          >{{
                            $t("myDeviceRentals.ExtendRental.Title")
                          }}</vs-button
                        >
                      </p>
                    </vs-td>
                    <vs-td
                      :data="data[indextr].tenant.display_name"
                      v-if="$route.meta.rent_tab == 3"
                    >
                      <p class="font-medium truncate mr-0">
                        {{
                          data[indextr].tenant
                            ? data[indextr].tenant.display_name
                            : "-"
                        }}
                      </p>
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
            </vs-table>
            <div class="center con-pagination p-5">
              <div class="flex items-center justify-end">
                <div>
                  <div class="con-vs-pagination vs-pagination-warning paginate">
                    <nav class="vs-pagination--nav">
                      <paginate
                        v-model="tablePage"
                        :page-count="tableTotalPagination"
                        prev-text="<i class='vs-icon notranslate icon-scale material-icons null'>chevron_left</i>"
                        next-text="<i class='vs-icon notranslate icon-scale material-icons null'>chevron_right</i>"
                        container-class="vs-pagination--nav vs-pagination--ul"
                        page-class="item-pagination vs-pagination--li"
                        active-class="is-current"
                        disabled-class="disabled"
                        prev-class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
                        next-class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next"
                      >
                      </paginate>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <vs-prompt
            blur
            @close="extendRentalModal = false"
            :active.sync="extendRentalModal"
            color="#626262"
            :title="$t('myDeviceRentals.ExtendRental.Title')"
            :buttons-hidden="true"
          >
            <div class="con-exemple-prompt text-center h5 py-6">
              <div class="mb-3">
                <feather-icon
                  class="text-muted"
                  icon="SmileIcon"
                  svgClasses="w-10 h-10"
                ></feather-icon>
              </div>
              {{ $t("myDeviceRentals.ExtendRental.WarningMessage") }}
            </div>
          </vs-prompt>
        </div>
      </div>
    </vx-card>
  </div>
</template>
<script>
import i18n from '../../i18n/i18n.js'
const moment = require('moment')
import Paginate from 'vuejs-paginate'
export default {
  data () {
    return {
      tab: 1,
      itemsPerPage: 10,
      tablePage: 1,
      tableTotalPagination: 1,
      rentalList: [],
      noDataText: i18n.t('table.NoData'),
      extendRentalModal: false
    }
  },
  components: {
    paginate: Paginate
  },
  mounted () {
    if (this.$route.meta.rent_tab === 1) {
      this.getUserRental('?status=1')
    } else if (this.$route.meta.rent_tab === 2) {
      this.getUserRental('?status=0')
    } else if (this.$route.meta.rent_tab === 3) {
      this.getUserRental('?status=-1')
    }
  },
  methods: {
    getDateFormat (date) {
      return moment(date).format('DD-MM-YYYY HH:mm')
    },
    getUserRental (filter) {
      this.noDataText = i18n.t('table.LoadingText')
      this.rentalList = []
      this.$store
        .dispatch('getUserRental', filter)
        .then((response) => {
          if (response.data.results.length === 0) {
            if (filter) {
              this.noDataText = i18n.t('table.NoMatch')
            } else {
              this.noDataText = i18n.t('table.NoData')
            }
            this.tableTotalPagination = 1
          } else {
            this.rentalList = response.data.results
            this.tableTotalPagination = Math.ceil(response.data.count / 10)
          }
        })
        .catch((error) => {
          this.noDataText = i18n.t('table.NoDataError')
          this.errorMsg(error)
        })
    },
    moveTo (link, tab) {
      this.$router.push(`/profile/device-rentals${  link}`).catch(() => {})
      this.tablePage = 1
      if (tab === 1) {
        this.getUserRental('?status=1')
      } else if (tab === 2) {
        this.getUserRental('?status=0')
      } else if (tab === 3) {
        this.getUserRental('?status=-1')
      }
    },
    errorMsg (error) {
      this.$store.dispatch('errorMsg', error).then((res) => {
        this.$vs.notify({
          title: i18n.t('notifyAlert.error.title'),
          text: res,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      })
    }
  },
  watch: {
    tablePage (val) {
      this.tablePage = val
      let filter = `?page=${  this.tablePage}`
      if (this.$route.meta.rent_tab === 1) {
        filter += '&status=1'
      } else if (this.$route.meta.rent_tab === 2) {
        filter += '&status=0'
      } else if (this.$route.meta.rent_tab === 3) {
        filter += '&status=-1'
      }
      this.getUserRental(filter)
    }
  }
}
</script>
<style lang="scss" scoped>
.list-group {
  .list-group-item {
    padding: 0.7rem 1.5rem;
    border-left: 2px solid transparent;

    .list-group-item-text {
      font-size: 14px;
      font-weight: 500;
      line-height: 1.5;
    }
    &.active {
      color: rgb(255, 159, 67);
      border-color: rgb(255, 159, 67);
    }
  }
}
.bg-light-primary {
  background: rgba(115, 103, 240, 0.12) !important;
}
.height-300 {
  min-height: 300px;
}
@media (min-width: 1350px) and (max-width: 1500px) {
  .xl\:w-1\/4 {
    width: 30% !important;
  }
  .xl\:w-3\/4 {
    width: 70% !important;
  }
}
@media (min-width: 992px) and (max-width: 1510px) {
  .tab-button {
    min-height: 60px !important;
    height: 100%;
  }
}
@media (min-width: 1200px) and (max-width: 1349.9px) {
  .xl\:w-1\/4 {
    width: 35% !important;
  }
  .xl\:w-3\/4 {
    width: 65% !important;
  }
}

.avatar-icon {
  .feather-user {
    width: 50px;
    height: 50px;
  }
}

.opacity-8 {
  opacity: 0.8;
}

.vs-button-warning-op-8.vs-button-warning {
  background: rgba(var(--vs-warning), 0.8) !important;
}
</style>
<style lang="scss">
#data-rental-device-view {
  .vs-con-table {
    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          width: 70px;
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;
        padding: 0 20px !important;
        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          justify-content: left !important;
          text-align: left;
        }
      }
      th.actions {
        .vs-table-text {
          justify-content: center !important;
        }
      }
      th.td-check {
        padding: 0 20px !important;
        width: 70px;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
  .vs-pagination--li.is-current {
    background: #ff9f43 !important;
  }
  .vs-pagination-primary .effect,
  .vs-pagination-primary .vs-pagination--buttons:hover {
    background: #ff9f43 !important;
  }

  .apiaries-list-part span {
    justify-content: center;
    display: flex;
    flex-wrap: wrap;
  }
  .not-data-table {
    background: #fff;
    padding: 20px;
    font-weight: 600;
    border-radius: 0.5rem;
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
  }
  .vs-table--tbody-table .tr-values.selected {
    cursor: default;
  }
}

.min-height {
  min-height: 600px;
}
</style>
